import axios from "axios";
//Limitless imports
import { log as pilog } from "common/utils/Logging";
import { handleAPIFailure } from "common/utils/api-log-helper/APILogHelper";
const createAttachmentHeaders = contentType => {
  return {
    headers: {
      "Content-Type": contentType
    }
  };
};
export const uploadAttachment = (url, attachment, callback) => {
  const log = pilog.getLogger("MessageActions uploadAttachment");
  log.debug(attachment);
  const reader = new FileReader();
  reader.onload = event => {
    axios.put(url, event.target.result, createAttachmentHeaders(attachment.type)).then(callback).catch(error => {
      handleAPIFailure(error, "MessageActions uploadAttachment");
      callback({
        hasError: true,
        error
      });
    });
  };
  try {
    reader.readAsArrayBuffer(attachment);
  } catch (error) {
    handleAPIFailure(error, "MessageActions Upload Attachment");
    callback({
      hasError: true,
      error
    });
  }
};